import React from 'react';
import './HowItWorks.css';
import onlineIcon from './../../assets/Images/icons/1.svg';
import offlineIcon from './../../assets/Images/icons/2.svg';
import telemostIcon from './../../assets/Images/icons/3.svg';

const HowItWorks: React.FC = () => {
  const items = [
    { icon: telemostIcon, title: 'Offline', description: '✨ World-Class Performers – Experience the mastery of Ilia Papoyan and a Bolshoi Theatre soloist in an intimate yet grand setting.' },
    { icon: offlineIcon, title: 'Digital', description: '✨ World-Class Performers – Experience the mastery of Ilia Papoyan and a Bolshoi Theatre soloist in an intimate yet grand setting.'  },
    { icon: onlineIcon, title: 'Online', description: '✨ World-Class Performers – Experience the mastery of Ilia Papoyan and a Bolshoi Theatre soloist in an intimate yet grand setting.'  },
   
  ];

  return (
    <section className="how-it-works">
      <h2 className="how-it-works-title">Type of Events</h2>
      <div className="how-it-works-grid">
        {items.map((item, index) => (
          <div className="how-it-works-item" key={index}>
            <img src={item.icon} alt={item.title} className="how-it-works-icon" />
            <h3 className="how-it-works-item-title">{item.title}</h3>
            <p className="how-it-works-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
